import { useMemo, useState } from 'react';
import { useTranslation } from 'translation/useTranslation';
import { matchPayoutPointsMapping } from 'helpers/payoutPointsMapping';

export default function PayoutPointsMapping({ settings, result }) {
  const { editableTranslate } = useTranslation();

  const [expanded, setExpanded] = useState(false);

  const { rows, matched } = useMemo(
    () => matchPayoutPointsMapping(settings?.performanceMapResultGrid, result),
    [settings, result]
  );

  if (!settings?.shouldConvertResultToPayoutPoints || rows.length === 0) return null;

  return <div className="payout-points-mapping mt-3">
    <div className="d-flex justify-content-between cursor-pointer" onClick={() => setExpanded(!expanded)} data-testid="payout-points-toggle">
      <span>
        <i className={`bi bi-chevron-${expanded ? 'up' : 'down'} mr-2`}></i>
        {editableTranslate('balanced_scorecard.payout_points_mapping', 'Zuordnungstabelle')}
      </span>
    </div>
    {
      expanded && <table className="payout-points-mapping-table w-auto mt-2">
        <tbody>
          <tr>
            <td className="font-weight-bold">{editableTranslate('balanced_scorecard.payout_points.result', 'Ergebnis')}</td>
            <td className="font-weight-bold text-right"><span className="ml-2"></span>{editableTranslate('balanced_scorecard.payout_points.value', 'Wert/Faktor')}</td>
          </tr>
          {
            rows.map((row, i) => (
              <tr key={i} className={row === matched ? 'font-weight-bold' : ''}>
                <td className={`${row === matched ? 'bg-white' : ''}`}>&gt;= {row.performanceResultMap}</td>
                <td className={`${row === matched ? 'bg-white' : ''} text-right`}>{row.performanceResultMapValueOrFactor}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    }
  </div>;
}
